import React, { createContext, useContext, useState, useEffect } from 'react';

const WishlistContext = createContext();

export const useWishlist = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlist must be used within WishlistProvider');
  }
  return context;
};

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    const saved = localStorage.getItem('wishlist');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('wishlist', JSON.stringify(items));
  }, [items]);

  const addItem = (product) => {
    if (!items.find(item => item.id === product.id)) {
      setItems([...items, product]);
      return true;
    }
    return false;
  };

  const removeItem = (productId) => {
    setItems(items.filter(item => item.id !== productId));
  };

  const isInWishlist = (productId) => {
    return items.some(item => item.id === productId);
  };

  const toggleItem = (product) => {
    if (isInWishlist(product.id)) {
      removeItem(product.id);
      return false;
    } else {
      addItem(product);
      return true;
    }
  };

  const clearWishlist = () => {
    setItems([]);
  };

  return (
    <WishlistContext.Provider value={{
      items,
      addItem,
      removeItem,
      isInWishlist,
      toggleItem,
      clearWishlist,
      totalItems: items.length,
    }}>
      {children}
    </WishlistContext.Provider>
  );
};
